export default __webpack_public_path__ + "static/media/proffy.be59f063.png";